module.exports = __webpack_public_path__ + "static/img/top-banner2-t.96ca3cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top-banner2-t.png
// module id = sXs0
// module chunks = 1